export default "__VITE_ASSET__CHZ2wJtY__";